export default __webpack_public_path__ + "static/media/birthday.89496471.svg";